var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewCalendar = function SvgNewCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.895,
    height: 23.698,
    viewBox: "4 -6 20 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5451",
    "data-name": "Caminho 5451",
    d: "M-2545.522-1489.848c.1-.961.314-1.281.859-1.294s.787.308.915,1.278h9.06c0-.129,0-.259,0-.39a.868.868,0,0,1,.887-.888.862.862,0,0,1,.837.9c0,.116,0,.232,0,.39h.3c.9,0,1.8,0,2.7,0a3.631,3.631,0,0,1,3.678,3.674q.007,7.537,0,15.074a3.612,3.612,0,0,1-3.642,3.65q-9.3.01-18.6,0a3.607,3.607,0,0,1-3.641-3.651q-.011-7.564,0-15.128a3.633,3.633,0,0,1,3.625-3.62c.908-.006,1.815,0,2.723,0Zm-4.927,7.413v.293q0,5.474,0,10.949a1.916,1.916,0,0,0,2.049,2.06h18.334a1.909,1.909,0,0,0,2.052-2.053q0-5.474,0-10.949v-.3Zm22.435-1.753c0-.656,0-1.293,0-1.929a1.9,1.9,0,0,0-1.994-2c-.9,0-1.8,0-2.7,0-.078,0-.156.01-.258.016,0,.141,0,.265,0,.389a.863.863,0,0,1-.854.889.872.872,0,0,1-.869-.88c-.006-.131,0-.263,0-.392h-9.076c-.01.192,0,.364-.03.531a.855.855,0,0,1-.912.739.866.866,0,0,1-.794-.838c-.006-.141,0-.283,0-.429a.979.979,0,0,0-.131-.022c-1.006,0-2.013-.017-3.02.005a1.772,1.772,0,0,0-1.732,1.5,22.251,22.251,0,0,0-.019,2.427Z",
    transform: "translate(2552.179 1491.142)",
    fill: "#7d7d7d"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_calendar.b0fde8d7.svg";
export { ForwardRef as ReactComponent };